import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const backendBase = (process.env.REACT_APP_BACKEND_URL || window.location.origin)
  .replace(/\/+$/, "")
  .replace(/\/api$/i, "");

const supabaseUrlToLocalBackup = (src) => {
  if (!src || typeof src !== "string") return null;
  if (!src.includes(".supabase.co/storage/v1/object/public/")) return null;

  const marker = "/storage/v1/object/public/Amorlias/";
  const markerIndex = src.indexOf(marker);
  if (markerIndex === -1) return null;

  const relativePath = src.slice(markerIndex + marker.length).replace(/^\/+/, "");
  if (!relativePath) return null;
  return `${backendBase}/uploads/${relativePath}`;
};

const localUploadToSupabaseBackup = (src) => {
  if (!src || typeof src !== "string") return null;
  let pathname = src;

  try {
    const parsed = new URL(src, window.location.origin);
    pathname = parsed.pathname;
  } catch {
    pathname = src;
  }

  if (!pathname.startsWith("/uploads/")) return null;
  const relativePath = pathname.replace(/^\/uploads\//, "");
  if (!relativePath) return null;

  return `https://dxudeuimspfzkbnihbia.supabase.co/storage/v1/object/public/Amorlias/${relativePath}`;
};

window.addEventListener(
  "error",
  (event) => {
    const target = event.target;
    if (!(target instanceof HTMLImageElement)) return;

    const currentSrc = target.currentSrc || target.src;
    if (!currentSrc) return;

    if (target.dataset.localFallbackTried !== "1") {
      const localFallback = supabaseUrlToLocalBackup(currentSrc);
      if (localFallback) {
        target.dataset.localFallbackTried = "1";
        target.src = localFallback;
        return;
      }
    }

    if (target.dataset.supabaseFallbackTried !== "1") {
      const supabaseFallback = localUploadToSupabaseBackup(currentSrc);
      if (supabaseFallback) {
        target.dataset.supabaseFallbackTried = "1";
        target.src = supabaseFallback;
      }
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        const notifyUpdate = () => {
          window.dispatchEvent(
            new CustomEvent("pwa-update", { detail: { registration } }),
          );
        };

        if (registration.waiting) {
          notifyUpdate();
        }

        registration.addEventListener("updatefound", () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
              notifyUpdate();
            }
          });
        });
      })
      .catch((error) => console.error("Service worker registration failed:", error));
  });
}
